import React, { Fragment, useEffect } from "react";
import { Spin } from "antd";

import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
// import { useGlobalInformationStore } from "@stores/global_informationStore";

import HospitalListCMService from "@services/hospital-list-and-case-manager.service";

import TableComponent from "../table/table";
import HopitalListAddAndUpdateModal from "../modal/modal";
import { tabKeyName } from "../FacilityInfo/FacilityInfo";
import Icon from "@assets/icon_config";
import "../hospitalMapping.scss";
import { forEach } from "lodash";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from '@components/accessLevel'

const HospitalListTable = (props: any) => {
  const primaryKey = "hosplst_name";
  const HOSPITAL_LIST_TAB_NAME = "Hospitalists";

  const setIsAddTableRowModalOpen = useHospitalMappingStore((state) => state.setIsAddTableRowModalOpen);
  const currentpageMode = useHospitalMappingStore((state) => state.pageCurrentMode);
  const setModalData = useHospitalMappingStore((state) => state.setModalData);
  const activeTab = useHospitalMappingStore((state) => state.activeTab);
  const setModalMode = useHospitalMappingStore((state) => state.setModalMode);
  const isHospitalListLoading = useHospitalMappingStore((state) => state.isHospitalListLoading);
  // const selectedHospitalListFacility = useGlobalInformationStore((state) => state.selectedHospitalListFacility);
  const isHospitalListTabColumnConfigLoaded = useHospitalMappingStore((state) => state.isHospitalListTabColumnConfigLoaded);

  useEffect(() => {
    console.log("HospitalListTable.useEffect");
    if (tabKeyName.hospitalists === activeTab) {
      setModalData({
        title: "Hospitalists",
        data: props.data,
        columnData: props.column,
        rowData: [],
      });
    }
    setModalMode("add");
  }, [activeTab, props, setModalData, setModalMode]);

  const softDeleteRow = (record: any) => {
    if (currentpageMode === "edit") {
      let body = {
        facilityName: record.facility_name,
        hospitalistName: record.hosplst_name,
        isDelete: record.is_active === "Y" ? true : false,
      };

      HospitalListCMService.editHospitalMapping(HOSPITAL_LIST_TAB_NAME, body).subscribe({
        next: (v) => {
          let temp = props.data.map((opt: any) => {
            let temp1 = { ...opt };
            if (record[props.primaryKey] === opt[props.primaryKey] && record?.hosplst_name === opt?.hosplst_name && record?.hosplst_phone_num === opt?.hosplst_phone_num) {
              temp1 = {
                ...temp1,
                is_active: record.is_active === "Y" ? "N" : "Y",
              };
            }
            return temp1;
          });
          props.setData(temp);
        },
        error: (e) => {
          console.log(e);
        },
      });
    }
  };

  const rowDataUpdate = (record: any) => {
    props.setData([
      ...props.data.map((hospital: any) => {
        let tempHospital: any = hospital;
        if (hospital.hosplst_name === record.hospitalistName) {
          tempHospital = {
            ...tempHospital,
            hosplst_name: record.newHospitalistName,
            hosplst_email_id: record.hospitalistMail,
            hosplst_fax_num: record.hospitalistFax,
            hosplst_phone_num: record.hospitalistPhone,
            hosplst_supvr_name: record.supervisorName,
            hosplst_supvr_phone_num: record.supervisorPhone,
          };
        }
        return tempHospital;
      }),
    ]);
  };

  const Add_new_row = (record: any) => {
    let tempHospitalObject = {
      facility_name: record.facilityName,
      hosplst_name: record.hospitalistName,
      hosplst_email_id: record.hospitalistMail,
      hosplst_fax_num: record.hospitalistFax,
      hosplst_phone_num: record.hospitalistPhone,
      hosplst_supvr_name: record.supervisorName,
      hosplst_supvr_phone_num: record.supervisorPhone,
      is_active: "Y",
    };
    props.setData([...props.data, tempHospitalObject]);
  };

  const validateHospitalName = (inputText:string) => {
    let validatedText = true;
    forEach( props.data , (hospital:any) => {
      if(hospital?.hosplst_name?.trim().toLowerCase() === inputText?.trim()?.toLowerCase())
        validatedText = false;
    })
    return {
      validation : validatedText,
      error_message : "Hospital Already Exists.!",
    };
  }

  return (
    <Fragment>
      {isHospitalListLoading || isHospitalListTabColumnConfigLoaded ? (
        <div className="hospital-cm-report-loader">
          <Spin size="large" className="hospital-cm-report-loader__spinner" indicator={<HealthemSpinner/>}/>
        </div>
      ) : (
        <Fragment>
          <div className="HospitalList-And-CM-TableComponent">
            <TableComponent column={props.column} data={props.data} setData={props.setData} primaryKey={primaryKey} delete={softDeleteRow} tab={HOSPITAL_LIST_TAB_NAME} />
            {currentpageMode === "edit" ? (
              <CanEdit>
              <div
                className="HospitalList-And-CM-TableComponent__add-row"
                onClick={() => {
                  setIsAddTableRowModalOpen(true);
                  setModalMode("add");
                }}
              >
                <div className="HospitalList-And-CM-TableComponent__add-row__icon">
                  <Icon name="addFacility" />
                </div>
                <div className="HospitalList-And-CM-TableComponent__add-row__title">Add Hospitalists</div>
              </div>
              </CanEdit>
            ) : null}
          </div>
          <HopitalListAddAndUpdateModal data={props.data} setData={props.setData} updateRow={rowDataUpdate} addRow={Add_new_row} validation = {validateHospitalName} hospitalData={ props.hospitalData } caseManagerData ={ props.caseManagerData } payorCaseManager = {props.payorCaseManager} hospitalSetData={props.hospitalSetData} caseManagerSetData={props.caseManagerSetData} payorCaseManagerSetData={props.payorCaseManagerSetData}/>
        </Fragment>
      )}
    </Fragment>
  );
};

export default HospitalListTable;
